import React from 'react';
import ListItem from './ListItem';
import ProfileModal from './ProfileModal';
import NotificationPreferences from './notifications/NotificationPreferences';
import { IRecipientPreference } from '@trycourier/react-hooks/typings/preferences/types';
import { useHistory } from 'react-router-dom';

interface NotificationsProps {
  isLoading: boolean;
  recipientPreferences: IRecipientPreference[];
}

const Notifications: React.FC<NotificationsProps> = ({
  isLoading,
  recipientPreferences,
}) => {
  const hasLoaded = recipientPreferences.length > 0;
  const notifsDisabled = recipientPreferences.every(
    (pref) => pref.status === 'OPTED_OUT'
  );
  const text =
    isLoading || !hasLoaded
      ? 'Loading...'
      : notifsDisabled
      ? 'Disabled'
      : 'Enabled';
  const history = useHistory();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if ((history.location.state as any)?.['open'] === 'notifications') {
      setOpen(true);
    }
    return () => {
      history.replace(history.location.pathname, {});
    };
  }, [history]);

  return (
    <>
      <ListItem
        title="Notifications"
        value={text}
        id="notifications"
        onClick={() => setOpen(true)}
      />

      <ProfileModal
        title="Notifications"
        isOpen={open}
        onClose={() => {
          history.replace(history.location.pathname, {});
          setOpen(false);
        }}
      >
        {({ close }) => <NotificationPreferences />}
      </ProfileModal>
    </>
  );
};

export default Notifications;
